/**
 * Color palette constants for consistent color generation across the application
 */

export const TRACE_COLORS = [
  "#4f46e5",
  "#22c55e",
  "#eab308",
  "#ec4899",
  "#06b6d4",
  "#f97316",
  "#8b5cf6",
  "#ef4444",
] as const;
